import Header from "../../components/Header/Header";
import AnalyticsTabs from "../../components/Analytics/AnalyticsTabs/AnalyticsTabs";
import { useEffect } from "react";
import { observer } from "mobx-react";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import AnalyticsStore from "../../store/AnalyticsStore";

import { setCookie } from "../../utils/cookie";
import { logEvents, trackEvent } from "../../utils/functions";
import { analyticsId, ANALYTICS_PAGE } from "../../utils/constants";
import { useLocation } from "react-router";
import * as Scroll from "react-scroll";
import PageTitle from "../../components/PageTitle/PageTitle";
const Analytics = observer(() => {
  const location = useLocation();

  const [tab, graph] = location?.state?.section?.split("/") || [
    undefined,
    undefined,
  ];

  useEffect(() => {
    PerformanceStore.setCurrentLoader("fullScreen");
    window.scrollTo(0, 0);
    if (UserStore.isHydrated) {
      let tab = "Overall";
      if (location.state) {
        const { section } = location.state;
        const [sectionTab] = section.split("/");
        tab = sectionTab;
      }
      UserStore.setSelectedAnalyticsTab(tab);
      setCookie("selectedTabA", analyticsId[tab]);
    }

    trackEvent(ANALYTICS_PAGE);
    logEvents(ANALYTICS_PAGE);
  }, []);

  useEffect(() => {
    let chartId = null;

    if (location.state) {
      const { section } = location.state;
      const [, sectionChart] = section.split("/");

      chartId = sectionChart;
    }

    if (chartId) {
      const chart = document.getElementById(chartId);

      if (chart) {
        false &&
          Scroll.animateScroll.scrollTo(chart?.getBoundingClientRect().top, {
            isDynamic: true,
            duration: 1700,
            smooth: true,
            delay: 100,
          });
      }
    }
  }, [AnalyticsStore.overall]);

  return (
    <>
      <PageTitle title={"Analytics"} />
      <Header type="analytics" />
      <div className="analytics__root">
        <div className="analytics__heading__section">
          <AnalyticsTabs
            snippetDuration={location.state?.duration || ""}
            mainSection={tab || ""}
            graphId={graph || tab || ""}
          />
        </div>
      </div>
    </>
  );
});

export default Analytics;
